import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import { FiCopy } from "react-icons/fi";
import { dashboardActions } from "../../../_actions";
import moment from "moment";
import { ArrowLeft, Clock, ChevronRight } from "lucide-react";
import { LuCalendarDays, LuClock } from 'react-icons/lu';
import { AiOutlineSave } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { MdOutlineClose } from "react-icons/md";
import { LuTrash2, LuBold, LuItalic, LuUnderline, LuAlignLeft, LuAlignCenter, LuAlignRight, LuAlignJustify } from 'react-icons/lu';
import { toast } from "react-toastify";
import DeleteNoteModal from "./Modals/DeleteNoteModal";


class MeetingLinks extends Component {
  constructor(props) {

    super(props);
    this.editorRef = createRef();

    this.state = {
      meetingCode: this.props.match.params.name.toString(),
      notes: "",
      noteId: "",
      selectedNoteIndex: null,
      isEditNote: false,
      showDeleteConfirm: false,
      crrNoteId: ""
    };
  }

  componentDidMount() {
    this.props.dispatch(dashboardActions.getConnectDetails({}));

    let { meetingCode } = this.state;
    let meetingName = "";
    if (meetingCode === "introduction") {
      meetingName = "Introduction & Orientation to Platform";
    } else if (meetingCode === "interview") {
      meetingName = "Behavioral Event Interview";
    } else if (meetingCode === "roleplay") {
      meetingName = "MS Teams Meeting Links (BEI, Case Study & Roleplay)";
    }

    this.props.dispatch(dashboardActions.saveInsightActivityTracking({
      activity: "Viewing " + meetingName
    }));
    this.props.dispatch(dashboardActions.getMeetingLinkDetails({}));
    this.props.dispatch(dashboardActions.getMeetingNotes({}));
  }

  handleSaveNotes = () => {
    const { meetingCode } = this.state;

    let body = this.editorRef.current ? this.editorRef.current.innerHTML : "";
    console.log("body-------------x-------------->", body)
    if (!body.trim()) return;

    this.props.dispatch(
      dashboardActions.saveMeetingNotes({
        meetingCode,
        notes: body,
      })
    );

    setTimeout(() => {
      this.setState({ notes: "", selectedNoteIndex: null }, () => {
        if (this.editorRef.current) {
          this.editorRef.current.innerHTML = "";
        }
      });
    }, 500)

  };

  handleCopy = (text) => {
    if (!text) return;
    toast("Meeting Linked Copied!")
    navigator.clipboard.writeText(text);
  };



  deleteNoteConfirm = (noteId) => {
    this.setState({ showDeleteConfirm: true, crrNoteId: noteId });
  }

  onCloseDeleteConfirm = () => {
    this.setState({ showDeleteConfirm: false, crrNoteId: "" });
  }

  handleNoteDelete = () => {
    let { crrNoteId } = this.state;
    this.props.dispatch(
      dashboardActions.deleteMeetingNotes({
        noteId: crrNoteId
      })
    );
    setTimeout(() => {
      this.setState({ showDeleteConfirm: false, crrNoteId: "" });
    }, 200)
  }


  handleSelectNote = (noteId, note, index) => {
    this.setState({
      notes: note,
      noteId: noteId,
      selectedNoteIndex: index
    });
  };

  goToLink = (meetLink) => {
    window.open(meetLink, "_blank");
  };

  goToBack = () => {
    let { noteId } = this.state;
    if (noteId) {
      this.setState({ noteId: "", notes: "", selectedNoteIndex: null });
    } else {
      window.history.back();
    }
  };


  editNotes = () => {
    let { notes } = this.state;
    this.setState({
      isEditNote: true
    }, () => {
      if (this.editorRef.current) {
        this.editorRef.current.innerHTML = notes || "";
      }
    });
  }

  closeNotes = () => {
    this.setState({ isEditNote: false });
  };


  saveEditNote = () => {
    let { meetingCode, noteId } = this.state;
    let body = this.editorRef.current ? this.editorRef.current.innerHTML : "";


    setTimeout(() => {
      this.setState({ notes: body, isEditNote: false }, () => {
        this.props.dispatch(
          dashboardActions.saveMeetingNotes({
            noteId: noteId,
            meetingCode: meetingCode,
            notes: body
          })
        );
        if (this.editorRef.current) {
          this.editorRef.current.innerHTML = "";
        }
      });
    }, 500)







  };


  render() {
    let { dashboard } = this.props;
    let { getMeetingLinkDetailsData = [], getMeetingNotesData = [] } = dashboard;

    let { showDeleteConfirm, noteId, isEditNote, meetingCode, notes, selectedNoteIndex } = this.state;
    let details = getMeetingLinkDetailsData;

    let meetLink = "";
    let meetingName = "";
    let meetingDateTime = {
      date: "",
      time: "",
    }

    let noteList = getMeetingNotesData?.filter((n) => n.meetingCode === meetingCode) || [];
    let crrNote = noteList[selectedNoteIndex];

    if (meetingCode === "introduction") {
      meetLink = details?.introMeetingLink ?? "";
      meetingName = "Introduction & Orientation to Platform";
    } else if (meetingCode === "interview") {
      meetLink = details?.caseStudyMeetingLink ?? "";
      meetingName = "Behavioral Event Interview";
    } else if (meetingCode === "roleplay") {
      meetLink = details?.rolePlayMeetingLink ?? "";
      meetingName = "MS Teams Meeting Links (BEI, Case Study & Roleplay)";
    }

    function DiscussionCard({ notes, index, isEditNote, editorRef, editNotes, saveEditNote, closeNotes }) {
      return (
        <>
          <div className="bg-white font-sans textblack">
            {isEditNote ?
              <>
                {/* Edit design */}
                <div className="w-full border border-gray-300 rounded-lg p-6">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
                    <h2 className="text-xl md:text-2xl font-medium md:mb-4 mb-0">Edit Note</h2>

                    <div className="flex flex-wrap justify-end gap-2 md:gap-3">
                      <button onClick={() => closeNotes()} className="flex items-center gap-2 px-3 md:px-5 py-2 border border-gray-300 rounded-md hover:border-red-500 hover:text-red-600 transition-all duration-200">
                        <MdOutlineClose size={18} />
                        <span className="text-sm md:text-base">Close</span>
                      </button>
                      <button onClick={() => saveEditNote()} className="flex items-center gap-2 px-3 md:px-5 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition-all duration-200">
                        <AiOutlineSave size={22} />
                        <span className="text-sm md:text-base">Save</span>
                      </button>
                    </div>


                  </div>
                  <div className="border border-gray-300 rounded-lg overflow-hidden">
                    <div className="flex flex-wrap textblack items-center gap-1 p-2 bg-[#F8FAFC] border-b border-gray-300">
                      <ToolbarButton icon={<LuBold />} />
                      <ToolbarButton icon={<LuItalic />} />
                      <ToolbarButton icon={<LuUnderline />} />
                      <div className="w-px h-6 bg-gray-200 mx-1"></div>
                      <ToolbarButton icon={<LuAlignLeft />} />
                      <ToolbarButton icon={<LuAlignCenter />} />
                      <ToolbarButton icon={<LuAlignRight />} />
                      <ToolbarButton icon={<LuAlignJustify />} />
                    </div>
                    <div
                      ref={editorRef}
                      contentEditable
                      className="w-full h-80 p-6 outline-none resize-none textblack leading-relaxed"
                      style={{ direction: "ltr", textAlign: "left" }}
                    />
                  </div>
                </div>
              </>
              :
              <>
                <div>
                  <div className="w-full border border-gray-300 rounded-lg p-6 md:p-8">
                    <div className="space-y-8">
                      <div>
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:pb-0 pb-3">
                          <h2 className="text-xl md:text-2xl font-medium md:mb-4 mb-0">Discussion Points:</h2>
                          <div className="flex flex-wrap justify-end gap-2 md:gap-3">
                            <button onClick={() => editNotes()} className="flex items-center gap-2 px-3 md:px-5 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition-all duration-200">
                              <AiOutlineSave size={22} />
                              <span className="text-sm md:text-base">Edit</span>
                            </button>
                          </div>
                        </div>
                        {/* <div className="space-y-6 p-4">
                          {notes}
                        </div> */}
                        <div
                          className="space-y-6 p-4"
                          dangerouslySetInnerHTML={{ __html: notes }}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </>
            }




          </div >
        </>
      );
    }

    let { getConnectDetailsData: x } = dashboard;
    let logo = x?.logo || "";

    return (
      <LayoutWrap logo={logo}>
        <div className="min-h-screen bg-white p-4 md:p-8 font-sans textblack">
          {/* Header */}
          <div className="mb-8 pb-4 border-b border-gray-300">
            <div className="flex items-center gap-4">
              <button onClick={() => this.goToBack()} className="p-2 rounded-full bg-indigo-100 text-indigo-600">
                <ArrowLeft size={24} />
              </button>
              <h1 className="md:text-2xl text-xl font-medium textblack">{meetingName}</h1>
            </div>
            {/* <div className="flex flex-wrap items-center gap-4 pt-2 ml-14 text-indigo-600 font-medium text-sm md:text-base">
              <div className="flex items-center gap-2">
                <LuCalendarDays size={18} /> {meetingDateTime.date}
              </div>
              <div className="flex items-center gap-2 border-l border-gray-300 pl-4">
                <LuClock size={18} /> {meetingDateTime.time}
              </div>
            </div> */}
          </div>

          {noteId ?
            <DiscussionCard
              notes={notes}
              index={selectedNoteIndex}
              editorRef={this.editorRef}
              isEditNote={isEditNote}
              saveEditNote={this.saveEditNote}
              editNotes={this.editNotes}
              closeNotes={this.closeNotes}
            />
            :
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
              {/* Left Section: Join Meeting */}
              <div className="lg:col-span-4 flex flex-col items-center">
                <div className="w-full border border-gray-300 rounded-lg p-6 md:p-10 flex flex-col items-center text-center space-y-8">
                  <div className="md:w-36 md:h-36 w-28 h-28 bg-indigo-100 rounded-full flex items-center justify-center">
                    <img src="/insight/group-meeting-call.svg" alt="Meeting Icon" className="md:w-20 md:h-20 w-16 h-16" />
                  </div>
                  <h2 className="md:text-xl text-lg font-medium">Join your Teams meeting</h2>
                  <div className="w-full space-y-4">
                    <button onClick={() => this.goToLink(meetLink)} className="w-full py-3 bg-indigo-600 text-white 2xl:text-lg text-base rounded-lg shadow-lg font-medium transition hover:bg-indigo-700">
                      Join this meeting
                    </button>
                    <button onClick={() => this.handleCopy(meetLink)} className="flex items-center justify-center gap-4 2xl:text-lg text-base w-full py-3 border border-gray-300 text-indigo-600 rounded-lg shadow-lg font-medium hover:bg-indigo-100 hover:text-indigo-700 transition">
                      <FiCopy size={20} />
                      <span>Copy meeting link</span>
                    </button>
                  </div>
                </div>
                {/* <div className="mt-8 text-center">
                <p className="textblack font-medium">Don't have the app?</p>
                <button className="text-indigo-600 font-medium underline mt-1">Download it now</button>
              </div> */}
              </div>

              {/* Right Section: Notes & List */}
              <div className="lg:col-span-8 space-y-8">

                {/* Quick Notes Input */}
                <div className="border border-gray-300 rounded-lg md:p-6 p-4 bg-white shadow-sm">
                  <h3 className="md:text-xl text-lg font-medium mb-4">Quick Notes</h3>

                  <div className="border border-gray-300 rounded-lg overflow-hidden">
                    <div className="flex flex-wrap textblack items-center gap-1 p-2 bg-[#F8FAFC] border-b border-gray-300">
                      <ToolbarButton icon={<LuBold />} />
                      <ToolbarButton icon={<LuItalic />} />
                      <ToolbarButton icon={<LuUnderline />} />
                      <div className="w-px h-6 bg-gray-200 mx-1"></div>
                      <ToolbarButton icon={<LuAlignLeft />} />
                      <ToolbarButton icon={<LuAlignCenter />} />
                      <ToolbarButton icon={<LuAlignRight />} />
                      <ToolbarButton icon={<LuAlignJustify />} />
                    </div>
                    <div
                      ref={this.editorRef}
                      contentEditable
                      className="w-full h-56 p-6 outline-none resize-none textblack leading-relaxed"
                      style={{ direction: "ltr", textAlign: "left" }}
                    />
                  </div>

                  {/* 
                  <textarea
                    placeholder="Write meeting note here..."
                    value={notes}
                    onChange={(e) => this.setState({ notes: e.target.value })}
                    className="w-full h-32 p-4 border border-gray-300 placeholder:textext-indigo-600t-[#5B21B6] textblack rounded-lg focus:ring-2 focus:ring-purple-200 focus:outline-none resize-none"
                  /> */}


                  <button
                    onClick={this.handleSaveNotes}
                    // disabled={!notes.trim()}
                    className="text-lg mt-4 flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2.5 rounded-lg font-medium">
                    Save <AiOutlineSave size={24} />
                  </button>
                </div>

                {/* Meeting Notes List */}
                {noteList && noteList.length > 0 && <div>
                  <div className="flex flex-col md:flex-row md:items-center justify-between w-full mb-4 gap-4">
                    <h3 className="md:text-xl text-lg font-medium">Your Meeting Notes</h3>
                  </div>

                  {/* Mapping the JSON Data */}
                  <div className="space-y-4">
                    {noteList && noteList.length > 0 ? (
                      noteList
                        .slice()
                        .reverse()
                        .map((ele, index) =>
                          <div key={index} className="flex items-center justify-between md:px-4 md:py-3 p-3 border border-gray-300 rounded-lg hover:shadow-md transition bg-white group">
                            <div className="space-y-2">
                              <div
                                className="font-medium md:text-lg text-base textblack line-clamp-2 mb-2"
                                dangerouslySetInnerHTML={{ __html: ele.notes }}
                              />

                              <div className="flex items-center gap-6 text-sm font-medium text-indigo-600">
                                <div className="flex items-center gap-2">
                                  <LuCalendarDays size={20} /> {ele && ele.createdAt ? moment(ele.createdAt).format("DD MMMM YYYY") : "Now"}
                                </div>
                                <div className="flex items-center gap-2 border-l border-gray-300 pl-4">
                                  <Clock size={20} /> {ele && ele.createdAt ? moment(ele.createdAt).format("hh:mm") : "Now"}
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center justify gap-3">
                              <div onClick={() => this.deleteNoteConfirm(ele.id)} className="md:p-2 p-1 flex items-center justify-center rounded-lg border border-red-200 bg-white hover:bg-red-50 hover:border-red-300 active:scale-95 shadow-sm hover:shadow transition-all duration-200 cursor-pointer">
                                <LuTrash2 size={18} className="text-red-500 group-hover:text-red-600 transition-colors" />
                              </div>
                              <div onClick={() => this.handleSelectNote(ele.id, ele.notes, index)} className="md:p-2 p-1 border border-gray-300 rounded-lg hover:bg-indigo-100 active:scale-95 shadow-sm hover:shadow transition-all duration-200 cursor-pointer">
                                <ChevronRight size={22} className="text-indigo-600" />
                              </div>
                            </div>
                          </div>
                        )) : null}
                  </div>
                </div>}


              </div>
            </div>}


          {showDeleteConfirm ?
            <>
              <DeleteNoteModal
                onDelete={this.handleNoteDelete}
                onClose={this.onCloseDeleteConfirm}
              />
            </>
            : null}


        </div>
      </LayoutWrap >
    );
  }
}

const ToolbarButton = ({ icon }) => (
  <button className="p-2 textblack font-semibold hover:bg-[#A78BFA] rounded transition-colors">
    {React.cloneElement(icon, { size: 18 })}
  </button>
);

const mapStateToProps = (state) => ({
  dashboard: state.dashboard,
});

export default connect(mapStateToProps)(MeetingLinks);